//@flow
import * as React from 'react'

type HeadingProps = {
  children: React.Node
}

const Heading = ({ children, ...props }: HeadingProps) => (
  <h2 style={{ fontWeight: 'normal' }} {...props}>
    {children}
  </h2>
)

export default Heading
